import { TextButtonType } from '@data/types';
import classNames from 'classnames';
import React from 'react';

interface Props extends TextButtonType {}

const MultiTextButton: React.FC<Props> = ({
  value,
  question: questionText = '',
  questionIndex = 0,
  answerIndex = 0,
  setSelectedAnswers = () => {},
  selectedAnswers,
}) => {
  // Get current results (ensure it's a flat array)
  const answerArray = selectedAnswers ? [...selectedAnswers] : [];

  // Find the relevant item in answerArray
  const existingAnswerIndex = answerArray.findIndex(
    (item) =>
      item.questionIndex === questionIndex && item.answerIndex === answerIndex
  );

  const selected =
    existingAnswerIndex !== -1 &&
    answerArray[existingAnswerIndex]?.answer === value;

  return (
    <button
      className={classNames(
        'bg-white rounded py-2 px-4 text-sm shadow hover:bg-blue hover:text-white hover:opacity-50 transition-all duration-300 capitalize w-full',
        {
          '!bg-blue !text-white !opacity-100': selected,
        }
      )}
      onClick={() => {
        const newAnswer = {
          question: questionText,
          answer: value,
          questionIndex,
          answerIndex,
        };

        if (existingAnswerIndex !== -1) {
          // Replace the existing answer
          answerArray[existingAnswerIndex] = newAnswer;
        } else {
          // Add the new answer to the array
          answerArray.push(newAnswer);
        }

        // Update the state with the new flat answerArray
        setSelectedAnswers(answerArray);
      }}
    >
      {value}
    </button>
  );
};

export default MultiTextButton;
